import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { api } from "@/src/services/api";
import organizationsReducer from "@/src/store/features/organizationsSlice";
import regulationsReducer from "@/src/store/features/regulationsSlice";
import articlesReducer from "@/src/store/features/articlesSlice";
import eventsReducer from "@/src/store/features/eventsSlice";
import bootstrapReducer from "@/src/store/features/bootstrapSlice";
import flashReducer from "@/src/store/features/flashSlice";
export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    organizations: organizationsReducer,
    regulations: regulationsReducer,
    articles: articlesReducer,
    events: eventsReducer,
    bootstrap: bootstrapReducer,
    flash: flashReducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(api.middleware)
});
setupListeners(store.dispatch);